﻿import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AlertService } from '../../_services';
import { RestService } from 'src/app/_services/rest.service';

@Component({ templateUrl: 'nuevo.component.html' })
export class NuevoProductoComponent implements OnInit {
    productoForm: FormGroup;
    loading = false;
    submitted = false;


    constructor(
        private formBuilder: FormBuilder,
        private restService: RestService,
        private alertService: AlertService
    ) {
    }

    ngOnInit() {
        this.productoForm = this.formBuilder.group({
            nombre: ['', [Validators.required]],
            url: ['', [Validators.required]],
            nombreImagen: ['', [Validators.required]],
            precio: ['', [Validators.required]]
        });

    }

    // convenience getter for easy access to form fields
    get f() { return this.productoForm.controls; }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.productoForm.invalid) {
            return;
        }

        const producto: any = {
            nombre: this.f.nombre.value,
            url: this.f.url.value,
            nombreImagen: this.f.nombreImagen.value,
            precio: this.f.precio.value
        } 

        this.loading = true;
        this.restService.post('/rest-api/root/producto/add', producto)
            .subscribe(
                data => {                    
                    if (data) {
                        this.alertService.success('<h3>Listo</h3>');
                        this.f.nombre.setValue('');
                        this.f.url.setValue('');
                        this.f.nombreImagen.setValue('');
                        this.f.precio.setValue('');
                        this.submitted = false;
                        this.loading = false;
                    }
                })
            ;
    }
    
}
